import React from "react";
import { useState, useEffect } from "react";
import { Modal, Button, Toast } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "../CSS/header.css";

const ClientDetailsModal = ({ showModal, handleClose }) => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    if(name !== "" && email !== "" && phone !== ""){
        let clientData = {
            clientName: name,
            clientEmail: email,
            clientNumber: Number(phone),
            clientMessage: message,
          };
          fetch('http://localhost:3000/client-info/create-client', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(clientData)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                setToastMessage('Sent successfully');
                setShowToast(true);
                setName('');
                setEmail('');
                setPhone('');
                setMessage('');
            })
            .catch(error => {
                console.error('Error:', error);
                setToastMessage('Error: Failed to send');
                setShowToast(true);
            });
    }
  }, [name, email, phone, message])

  const saveDetails = (e) => {
    e.preventDefault();

    if (name === "" || email === "" || phone === "") {
      setShowToast(true);
      return;
    }

    let clientData = {
      clientName: name,
      clientEmail: email,
      clientNumber: Number(phone),
      clientMessage: message,
    };
    console.log(clientData, "CLIENTDATA");
  };

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Send Your Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: "bold" }}>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g John Wick"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: "bold" }}>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="e.g name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: "bold" }}>Phone</Form.Label>
            <Form.Control
              type="text"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: "bold" }}>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Write Message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-success" onClick={saveDetails}>
          Save
        </Button>
        <Button variant="outline-danger" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>

      <Toast
        show={showToast}
        onClose={() => setShowToast(false)}
        bg="danger"
        delay={3000} 
        autohide
        style={{ position: "absolute", top: "500px", left: "0px", zIndex: 1 }}>
        <Toast.Body
        style={{color:"white", fontSize:"20px", fontFamily:"Roboto"}}
        >Please fill all the fields</Toast.Body>
      </Toast>
    </Modal>
  );
};

export default ClientDetailsModal;
